<template>
  <el-table-column
    prop="web_price"
    sortable="custom"
    label="Web ár"
    show-overflow-tooltip
    min-width="100"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.web_price">{{ (scope.row.web_price || 0) | currency }}</span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'web_price',
};
</script>
